import {
  Button,
  color,
  IconArrowLeft,
  IconClose,
  spacing,
  styled,
  TextElement,
  Truncate,
} from '@lessonup/ui-components';
import React from 'react';

export interface ContextSidebarHeaderProps {
  title: string;
  onClosePane: () => void;
  closeLabel: string;
  buttonRef?: React.Ref<HTMLButtonElement>;
  showBackButtonInsteadOfCloseButton?: boolean;
}

export const ContextSidebarHeader: React.FC<ContextSidebarHeaderProps> = ({
  title,
  onClosePane,
  closeLabel,
  buttonRef,
  showBackButtonInsteadOfCloseButton = false,
}) => (
  <StyledContextSidebarHeader $showBackButton={showBackButtonInsteadOfCloseButton}>
    {showBackButtonInsteadOfCloseButton && (
      <Button
        buttonType="neutral"
        size="small"
        onClick={onClosePane}
        aria-label={closeLabel}
        ref={buttonRef}
        iconStart={<IconArrowLeft />}
      />
    )}
    <Truncate>
      <TextElement weight="bold" size="medium" textStyle="bodyText">
        {title}
      </TextElement>
    </Truncate>
    {!showBackButtonInsteadOfCloseButton && (
      <Button
        buttonType="neutral"
        size="small"
        onClick={onClosePane}
        aria-label={closeLabel}
        ref={buttonRef}
        iconStart={<IconClose />}
      />
    )}
  </StyledContextSidebarHeader>
);

const StyledContextSidebarHeader = styled.section<{ $showBackButton?: boolean }>`
  padding: ${spacing.size8} ${spacing.size16};
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: ${color.neutral.surface.background};
  z-index: 1; // this is needed to have a border when the header is sticky, is should be above dropdowns in the sidebar

  ${({ $showBackButton }) =>
    $showBackButton
      ? `
        justify-content: flex-start;
        gap: ${spacing.size8};
      `
      : `
        justify-content: space-between;
      `}
`;
